// import MonitorStockOutbound from '@/pages/MonitorStockOutbound';
// import MonitorStock from '@/pages/MonitorStock';
// import MonitorStockAdjust from '@/pages/MonitorStockAdjust';
// import MonitorStockAgv from '@/pages/MonitorStockAgv';
// import MonitorInboundOrder from '@/pages/MonitorInboundOrder';
// import MonitorInboundBackOrder from '@/pages/MonitorInboundBackOrder';
// import MonitorInboundBackStock from '@/pages/MonitorInboundBackStock';
// import MonitorInboundBackEf from '@/pages/MonitorInboundBackEf';
// import InboundRepush from '@/pages/InboundRepush';
// import BatchMoveLocation from '@/pages/BatchMoveLocation';
import React from 'react';

export default [
  {
    path: '/dev/monitor/stock',
    // component: MonitorStock,
    exact: true,
    component: React.lazy(() => import(/* webpackChunkName: 'MonitorStock' */ '@/pages/MonitorStock')),
  },

  {
    path: '/dev/monitor/outbound',
    // component: MonitorStockOutbound,
    exact: true,
    component: React.lazy(() => import(/* webpackChunkName: 'MonitorStockOutbound' */ '@/pages/MonitorStockOutbound')),
  },

  {
    path: '/dev/inbound/repush',
    // component: InboundRepush,
    component: React.lazy(() => import(/* webpackChunkName: 'InboundRepush' */ '@/pages/InboundRepush')),
  },

  {
    path: '/monitor/stock/agv',
    // component: MonitorStockAgv,
    exact: true,
    component: React.lazy(() => import(/* webpackChunkName: 'MonitorStockAgv' */ '@/pages/MonitorStockAgv')),
  },

  {
    path: '/monitor/inbound/order',
    // component: MonitorInboundOrder,
    exact: true,
    component: React.lazy(() => import(/* webpackChunkName: 'MonitorInboundOrder' */ '@/pages/MonitorInboundOrder')),
  },

  {
    path: '/monitor/inbound/back/order',
    // component: MonitorInboundBackOrder,
    exact: true,
    component: React.lazy(
      () => import(/* webpackChunkName: 'MonitorInboundBackOrder' */ '@/pages/MonitorInboundBackOrder'),
    ),
  },

  {
    path: '/monitor/inbound/back/stock',
    // component: MonitorInboundBackStock,
    exact: true,
    component: React.lazy(
      () => import(/* webpackChunkName: 'MonitorInboundBackStock' */ '@/pages/MonitorInboundBackStock'),
    ),
  },

  {
    path: '/monitor/inbound/back/ef',
    // component: MonitorInboundBackEf,
    exact: true,
    component: React.lazy(() => import(/* webpackChunkName: 'MonitorInboundBackEf' */ '@/pages/MonitorInboundBackEf')),
  },

  {
    path: '/dev/move/location',
    // component: BatchMoveLocation,
    component: React.lazy(() => import(/* webpackChunkName: 'BatchMoveLocation' */ '@/pages/BatchMoveLocation')),
  },
];
